import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { TimelineStore } from '../timeline.store';
import { Subscriber } from 'rxjs/Subscriber';

@Component({
  selector: 'app-timeline-slider',
  templateUrl: './timeline-slider.component.html',
  styleUrls: ['./timeline-slider.component.styl']
})
export class TimelineSliderComponent implements OnInit, OnDestroy {
  public changeSubscriber: Subscriber<number>;

  @ViewChild('element') element: ElementRef;

  constructor(private timelineStore: TimelineStore) {
  }

  ngOnInit() {
    this.updatePosition();
    this.changeSubscriber = this.timelineStore.change
      .subscribe(() => this.updatePosition());
  }

  ngOnDestroy() {
    this.changeSubscriber.unsubscribe();
  }

  updatePosition() {
    this.element.nativeElement.style.left = this.getPosition() + 'px';
  }

  getPosition() {
    return this.timelineStore.halfWidth - this.timelineStore.currentPositionInPixels;
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-slider/timeline-slider.component.ts